<template>
  <div class="">
    
    <CCard>
     <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("cB2BPayment.setup") }}</strong>
          </CCol>
          <p class="desc">{{ $t("cB2BPayment.desc") }}</p>
        </CRow>

      </CCardHeader>
      <CCardBody
        v-if="
          selectedPayment &&
            selectedPayment.paymentsettingsid &&
            lsPaymentTypes &&
            lsPaymentTypes.length
        "
      >
        <cPaymentTypes
          v-if="selectedPayment && selectedPayment.paymentsettingsid"
          :selPayments="lsPaymentTypes"
          :pSettID="selectedPayment.paymentsettingsid"
          :isSetup="true"
        >
        </cPaymentTypes>
      </CCardBody>
      <CCardFooter>
        <CCol class="text-right mob-btn-center">
          <CRow class="d-flex justify-content-end ">
            <CButton color="danger"  class="action-c-btn" @click=' redirectToPSetup()'>



              {{$t('paymentFee.goBack')}}
            </CButton>



          </CRow>
        </CCol>


      </CCardFooter>

    </CCard>
  </div>
</template>

<script>

import cDropDown from "./../../components/form/cDropDown";
import cOrgCurrencyDp from "./../../components/currency/cOrgCurrencyDp";
import cTextInputComponent from "./../../components/form/cTextInputComponent";

import cPaymentTypes from "./../../components/payment/cPaymentTypes.vue"
import Multiselect from "vue-multiselect";
import router, { navigate, goBack } from "../../router/index";
import { cloneData, removeDuplicates, OrderByList,addClassToBody,removeClassBody } from "./../../util/util";
import { ValidationObserver, localize } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS
} from "./../../util/constants";
import apiCreatePayment from "./../../services/apiCreatePayment";
import apiUpdatePayment from "./../../services/apiUpdatePayment";
import Logger from "./../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
  API_VALUES
} from "./../../config/API_DATA";
import BaseConfiguration from "./../../config/base";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import apiGetPaymentTypes from "./../../services/apiGetPaymentTypes";
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.PAYMENT_FEE,
  components: {
    cPaymentTypes
  },
  computed: {
    ...mapGetters("sPaymentSetup", { selectedPayment: "GET_SELECTED_PAYMENT" })
  },
  data: () => {
    return {
      paymentObj: null,
      lsPaymentTypes: [],
      alertValue: null
    };
  },
  methods: {


    redirectToPSetup()
    {
               goBack(-2);
    },
    async getPaymentTypes(pPaymentSettID) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getPaymentTypes");
        let paymentTypesReq = apiGetPaymentTypes.buildRequest(pPaymentSettID);
        if (paymentTypesReq && pPaymentSettID != null) {
          let paymentTypesRes = await apiGetPaymentTypes.getResponse(
            paymentTypesReq
          );
          if (VALIDATE_SUCCESS_RES(paymentTypesRes)) {
            retValue = paymentTypesRes.data.data;
            this.alertValue = null;
          } else {
            let error = getErrorMessage(paymentTypesRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid  payment setting id";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.PAYMENT_FEE,
          "error in getPaymentTypes",
          err.toString(),
          "getPaymentTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },

  async created(pName) {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      if (this.selectedPayment && this.selectedPayment.paymentsettingsid)
        this.lsPaymentTypes = await this.getPaymentTypes(
          this.selectedPayment.paymentsettingsid
        );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.PAYMENT_FEE,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.PAYMENT_FEE);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>

<style scoped></style>
